import React from 'react';
import { Layout, Type, Image } from 'lucide-react';

const SECTION_TYPES = [
  { type: 'hero', label: 'Hero Section', icon: Layout },
  { type: 'features', label: 'Features', icon: Layout },
  { type: 'about', label: 'About', icon: Type },
  { type: 'services', label: 'Services', icon: Layout },
  { type: 'testimonials', label: 'Testimonials', icon: Type },
  { type: 'pricing', label: 'Pricing', icon: Layout },
  { type: 'gallery', label: 'Gallery', icon: Image },
  { type: 'contact', label: 'Contact', icon: Type },
  { type: 'cta', label: 'Call to Action', icon: Layout },
  { type: 'footer', label: 'Footer', icon: Layout },
];

export const AddSectionModal = ({ onAdd, onClose }) => (
  <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
    <div className="bg-[#302f2c] border border-[#1e3a5f]/50 rounded-lg max-w-lg w-full">
      <div className="p-4 border-b border-[#1e3a5f]/50 flex items-center justify-between">
        <h2 className="text-[#7dd3fc] font-bold text-lg">Add Section</h2>
        <button onClick={onClose} className="text-[#888680] hover:text-[#7dd3fc]">✕</button>
      </div>
      <div className="p-4 grid grid-cols-2 gap-3 max-h-96 overflow-y-auto">
        {SECTION_TYPES.map(({ type, label, icon: Icon }) => (
          <button
            key={type}
            onClick={() => onAdd(type)}
            data-testid={`add-section-type-${type}`}
            className="p-4 bg-[#1a1c1b] border border-[#1e3a5f]/50 rounded-lg hover:border-[#7dd3fc]/50 transition-all text-left group"
          >
            <Icon className="w-6 h-6 text-[#888680] group-hover:text-[#7dd3fc] mb-2" />
            <span className="text-[#7dd3fc] font-medium text-sm block">{label}</span>
          </button>
        ))}
      </div>
    </div>
  </div>
);
